import {EventEmitter} from "@angular/core";
import {AtmStrikeChangedEvent} from "./atm-strike-changed-event";
import {AtmStrategy} from "./atm-strategy";
import {QuoteDto} from "../../shell-communication/dtos/quote-dto.class";
import {isValidNumber, isVoid, roundToStep, getStrikeStep} from "../../utils";

export class AtmWatcher {

    constructor(private _underlying: string, private _strategy: AtmStrategy = 'Midpoint') {
        this._strikeStep = getStrikeStep(_underlying);
    }

    private readonly _strikeStep: number;

    private _previousAtm: number;
    private _currentAtm: number;
    private _upperThreshold: number;
    private _lowerThreshold: number;

    //
    atmChanged$ = new EventEmitter<AtmStrikeChangedEvent>();

    //
    get atm(): number {
        return this._currentAtm;
    }

    //
    get strategy(): AtmStrategy {
        return this._strategy;
    }

    //
    onQuote(quote: QuoteDto) {
        if (this._underlying != quote.ticker) {
            return;
        }

        if (this._strategy === 'Sticky') {
            this.onQuoteSticky(quote);
        } else {
            this.onQuoteMidpoint(quote);
        }
    }

    //
    broadcast() {

        if (this._currentAtm === this._previousAtm) {
            return;
        }

        this.atmChanged$.emit({
            underlying: this._underlying,
            previousAtm: this._previousAtm,
            currentAtm: this._currentAtm,
            strategy: this._strategy
        });

        this._previousAtm = this._currentAtm;

    }

    //
    private onQuoteMidpoint(quote: QuoteDto) {
        this._previousAtm = this._currentAtm;
        this._currentAtm = roundToStep(quote.lastPx, this._strikeStep);
        this.broadcast();
    }

    //
    private onQuoteSticky(quote: QuoteDto) {
        const lastPx = quote.lastPx;

        if (!isValidNumber(this._currentAtm)) {
            this._currentAtm = roundToStep(lastPx, this._strikeStep);
            this._previousAtm = this._currentAtm;
            this.setThresholds();
            return;
        }

        if (lastPx >= this._upperThreshold || lastPx <= this._lowerThreshold) {
            this._previousAtm = this._currentAtm;
            this._currentAtm = roundToStep(lastPx, this._strikeStep);
            this.setThresholds();
            this.broadcast();
        }
    }

    //
    private setThresholds() {
        this._upperThreshold = this._currentAtm + this._strikeStep;
        this._lowerThreshold = this._currentAtm - this._strikeStep;
    }
}
